export default function getParsedToken (accessTokenArg) {
  const accessToken = accessTokenArg ?? localStorage.getItem('access_token');
  const tokenPayload = JSON.parse(atob(accessToken.split('.')[1]));

  return tokenPayload;
}
